namespace $.$$ {

	export class $shm_dashboard_admin_settings extends $.$shm_dashboard_admin_settings {

		settings_rows() {
			return this.scope() === 'notifications'
				? [ this.Notifications() ]
				: [ this.Defaults(), this.Notifications() ]
		}

		settings_records() {
			return this.$.$shm_pb.admin_records_page_realtime(
				`wordstat_worker_settings\n\n-updated\n1\n1`,
			)
		}

		settings_record() {
			return this.settings_records()[0] ?? null
		}

		setting_number( field: string, fallback: number ) {
			const value = Number( this.settings_record()?.[ field ] ?? fallback )
			return Number.isFinite( value ) ? Math.max( 0, Math.floor( value ) ) : fallback
		}

		setting_text( field: string ) {
			return String( this.settings_record()?.[ field ] ?? '' )
		}

		@ $mol_mem_key
		draft( field: string, next?: string ) {
			$mol_wire_solid()
			if( next !== undefined ) return next
			switch( field ) {
				case 'default_wordstat_task_limit': return String( this.setting_number( field, 100 ) )
				case 'default_wordstat_hourly_request_limit': return String( this.setting_number( field, 1000 ) )
				case 'default_wordstat_regular_daily_task_limit': return String( this.setting_number( field, 100 ) )
				case 'default_wordstat_query_limit': return String( this.setting_number( field, 200 ) )
				case 'default_wordstat_subtask_limit': return String( this.setting_number( field, 1000 ) )
				default: return this.setting_text( field )
			}
		}

		default_task_limit_draft( next?: string ) {
			return this.draft( 'default_wordstat_task_limit', next )
		}

		default_hourly_limit_draft( next?: string ) {
			return this.draft( 'default_wordstat_hourly_request_limit', next )
		}

		default_regular_daily_limit_draft( next?: string ) {
			return this.draft( 'default_wordstat_regular_daily_task_limit', next )
		}

		default_query_limit_draft( next?: string ) {
			return this.draft( 'default_wordstat_query_limit', next )
		}

		default_subtask_limit_draft( next?: string ) {
			return this.draft( 'default_wordstat_subtask_limit', next )
		}

		max_token_draft( next?: string ) {
			return this.draft( 'max_bot_token', next )
		}

		telegram_token_draft( next?: string ) {
			return this.draft( 'telegram_bot_token', next )
		}

		max_chat_id_draft( next?: string ) {
			return this.draft( 'max_chat_id', next )
		}

		telegram_chat_id_draft( next?: string ) {
			return this.draft( 'telegram_chat_id', next )
		}

		limit_value( value: string, minimum = 0 ) {
			return Math.max( minimum, Math.floor( Number( value ) || 0 ) )
		}

		@ $mol_action
		setting_save( field: string, value: string | number | boolean ) {
			const record = this.settings_record()
			if( record ) {
				this.$.$shm_pb.update_record( 'wordstat_worker_settings', record.id, { [ field ]: value } )
				return
			}

			this.$.$shm_pb.create_record( 'wordstat_worker_settings', {
				enabled: false,
				default_wordstat_task_limit: 100,
				default_wordstat_hourly_request_limit: 1000,
				default_wordstat_regular_daily_task_limit: 100,
				default_wordstat_query_limit: 200,
				default_wordstat_subtask_limit: 1000,
				max_bot_token: '',
				max_chat_id: '',
				telegram_bot_token: '',
				telegram_chat_id: '',
				[ field ]: value,
			} )
		}

		limit_commit( field: string, draft: string, minimum = 0 ) {
			const value = this.limit_value( draft, minimum )
			this.draft( field, String( value ) )
			if( !this.settings_record() || value !== this.setting_number( field, value ) ) this.setting_save( field, value )
		}

		default_task_limit_commit( next?: Event ) {
			if( next !== undefined ) this.limit_commit( 'default_wordstat_task_limit', this.default_task_limit_draft() )
			return next ?? null
		}

		default_hourly_limit_commit( next?: Event ) {
			if( next !== undefined ) this.limit_commit( 'default_wordstat_hourly_request_limit', this.default_hourly_limit_draft() )
			return next ?? null
		}

		default_regular_daily_limit_commit( next?: Event ) {
			if( next !== undefined ) this.limit_commit( 'default_wordstat_regular_daily_task_limit', this.default_regular_daily_limit_draft() )
			return next ?? null
		}

		default_query_limit_commit( next?: Event ) {
			if( next !== undefined ) this.limit_commit( 'default_wordstat_query_limit', this.default_query_limit_draft(), 1 )
			return next ?? null
		}

		default_subtask_limit_commit( next?: Event ) {
			if( next !== undefined ) this.limit_commit( 'default_wordstat_subtask_limit', this.default_subtask_limit_draft(), 1 )
			return next ?? null
		}

		notifications_enabled( next?: boolean ) {
			if( next !== undefined ) this.setting_save( 'enabled', next )
			return next ?? Boolean( this.settings_record()?.enabled )
		}

		max_token_commit( next?: Event ) {
			if( next === undefined ) return null
			const value = this.max_token_draft().trim()
			this.max_token_draft( value )
			if( value !== this.setting_text( 'max_bot_token' ) ) this.setting_save( 'max_bot_token', value )
			return next
		}

		telegram_token_commit( next?: Event ) {
			if( next === undefined ) return null
			const value = this.telegram_token_draft().trim()
			this.telegram_token_draft( value )
			if( value !== this.setting_text( 'telegram_bot_token' ) ) this.setting_save( 'telegram_bot_token', value )
			return next
		}

		max_chat_id_commit( next?: Event ) {
			if( next === undefined ) return null
			const value = this.max_chat_id_draft().trim()
			this.max_chat_id_draft( value )
			if( value !== this.setting_text( 'max_chat_id' ) ) this.setting_save( 'max_chat_id', value )
			return next
		}

		telegram_chat_id_commit( next?: Event ) {
			if( next === undefined ) return null
			const value = this.telegram_chat_id_draft().trim()
			this.telegram_chat_id_draft( value )
			if( value !== this.setting_text( 'telegram_chat_id' ) ) this.setting_save( 'telegram_chat_id', value )
			return next
		}

	}

}
